<template>
	<div>
		<div
			id="drop-zone"
			class="elevation-2"
			:class="{ dragging: is_dragging }"
			@dragover="dragover"
			@dragleave="dragleave"
			@drop="drop">
			<input
				type="file"
				multiple
				name="ticket_form_fileinput"
				id="ticket_form_fileinput"
				class="hidden-input"
				@change="onChange($event.target.files)"
				ref="ticket_form_fileinput" />
			<label for="ticket_form_fileinput" class="file-label">
				<v-layout row wrap align-center justify-center>
					<v-flex shrink>
					<v-icon :size="80" class="mr-3" color="primary">
						cloud_upload
					</v-icon>
					</v-flex>
					<v-flex shrink class="subheading">
						Déposez vos images ici ou collez une capture via
					</v-flex>
					<v-flex shrink>
						<v-chip label color="background" class="elevation-4 ml-3">
							CTRL + V
						</v-chip>
					</v-flex>
				</v-layout>
			</label>
			<v-container grid-list-md class="pa-2" v-if="Object.keys(items).length">
				<v-layout row wrap>
					<v-flex
						shrink
						v-for="(item, filename) in items"
						:key="filename">
						<Attachment
							:item="item"
							@delete="$emit('delete', filename)">
						</Attachment>
					</v-flex>
				</v-layout>
			</v-container>
		</div>
	</div>
</template>

<script>
import Attachment from '@/pages/about/ticket_attachment_item.vue'
export default {
	components: { Attachment },
	props: [ 'items' ],
	data () {
		return {
			is_dragging: false,
			image_exts: this.$getConst('TICKET_IMAGES_EXTS'),
			document_exts: this.$getConst('TICKET_DOCUMENTS_EXTS'),
			max_file_size: this.$getConst('TICKET_ATTACHMENT_MAXSIZE')
		}
	},
	methods: {
		dragover (evt) {
			evt.preventDefault()
			this.is_dragging = true
		},
		dragleave () {
			this.is_dragging = false
		},
		drop (evt) {
			evt.preventDefault()
			this.onChange(evt.dataTransfer.files)
			this.is_dragging = false
		},
		addFile (file, fileName) {
			if (this.items.hasOwnProperty(fileName)) return
			let fileExt = file.name.substring(file.name.lastIndexOf('.'))
			fileExt = fileExt.toLowerCase()
			let type = 'document'
			if (this.image_exts.indexOf(fileExt) > -1) type = 'image'
			let fileData = {
				file: file,
				name: fileName,
				type: type,
				uploading: false,
				done: false,
				error: false,
				progress: 0,
				block_reasons: []
			}
			if (file.size / 1000 > this.max_file_size.value) {
				fileData.block_reasons.push(
					`Fichier trop lourd > ${this.max_file_size.text}`
				)
			}
			if (this.image_exts.indexOf(fileExt) === -1 &&
					this.document_exts.indexOf(fileExt) === -1) {
				fileData.block_reasons.push(
					`Extension de fichier interdite : ${fileExt}`
				)
			}
			if (fileExt === file.name && !file.type && file.size % 4096 === 0) {
				fileData.block_reasons.push(
					'Les dossiers ne sont pas pris en charge'
				)
			}
			this.$emit('add', fileData)
		},
		onChange (files) {
			for (const file of files) {
				this.addFile(file, file.name)
			}
		},
		onPaste (event) {
			let item = (
				event.clipboardData || event.originalEvent.clipboardData
			).items[0]
			if (item.type.indexOf('image') === 0) {
				let file = item.getAsFile()
				let existingImages = Object.keys(this.items).filter(element => {
					return /image_\d+\.png/.test(element)
				})
				let attachments = this.$commons.deepGet(this.ticket, 'attachments', [])
				for (const attachment of attachments) {
					if (/image_\d+\.png/.test(attachment.label)) {
						existingImages.push(attachment.label)
					}
				}
				let fileName = `image_${existingImages.length + 1}.png`
				this.addFile(file, fileName)
			}
		}
	},
	mounted () {
		window.document.addEventListener('paste', this.onPaste, true)
	},
	beforeDestroy () {
		window.document.removeEventListener('paste', this.onPaste, true)
	}
}
</script>

<style lang="stylus" scoped>
#drop-zone
	min-height: 86px
	color: var(--v-primary-base)
	width: 100%
	position: relative
	border-radius: 2px
	background-color: var(--v-background-darken1) !important
	border: 1px solid var(--v-background-lighten1)
	&.dragging
		background-color: #84ffff54 !important
		border: 1px solid var(--v-primary-base)
	&:hover
		background-color: #84ffff54 !important
		border: 1px solid var(--v-primary-base)

.hidden-input
	opacity: 0
	overflow: hidden
	position: absolute
	width: 1px
	height: 1px

.file-label
	width: 100%
	margin: 0
	padding-left: 12px
	cursor: pointer
</style>



// WEBPACK FOOTER //
// src/pages/about/ticket_form_attachment.vue